import { render, staticRenderFns } from "./send-product-payment-reminder-message-drawer.vue?vue&type=template&id=46627303&scoped=true&"
import script from "./send-product-payment-reminder-message-drawer.vue?vue&type=script&lang=ts&"
export * from "./send-product-payment-reminder-message-drawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46627303",
  null
  
)

export default component.exports